import React, { useState } from "react";
import { cuseDispatch, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import API from "../../constants/api";

import * as APIS from "../../constants/apis";
import { deleteUserAction } from "../../redux/actions/UsersAction";

const GroupDeleteItem = ({ t, user, clearDelete }) => {
  const dispatch = useDispatch()
  const [isUpdating, setIsUpdating] = useState(false)

  const activeOrDeactive = (users, isActive) => {
    let data = users
    data.active = isActive;
    if (
      window.confirm(
        `${t("alerts.users-item-4")} ${isActive ? t("alerts.users-item-5") : t("alerts.users-item-6")
        } ${t("alerts.users-item-7")}`
      )
    ) {
      setIsUpdating(true)
      API
        .putUser(data.uid, data)
        .then((data) => {
          toast.success(
            `${isActive ? t("alerts.users-item-8") : t("alerts.users-item-9")
            } ${t("alerts.users-item-10")}`
          );
          clearDelete(data.uid);
          setIsUpdating(false)
        })
        .catch((error) => {
          if (error.response.status != 200) {
            toast.error(error.response.data.message)
            setIsUpdating(false)
          }
        });
    }
  };

  if (isUpdating) {
    return (
      <button class="btn btn-info" type="button" disabled={isUpdating ? true : false}>
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      </button>
    )
  }

  return (
    <>
      {
        !user.active ?
          <button
            className="btn btn-info mr-2"
            data-toggle="modal"
            data-target="#updateStatus"
            onClick={(e) => activeOrDeactive(user, true)}
          >
            {/* <i className="fa fa-exclamation-triangle"></i>{" "} */}
            {t("globals.active")}
          </button>
          :
          <button
            className="btn btn-info mr-2"
            data-toggle="modal"
            data-target="#updateStatus"
            onClick={(e) => activeOrDeactive(user, false)}
          >
            {/* <i className="fa fa-exclamation-triangle"></i>{" "} */}
            {t("globals.deactive")}
          </button>
      }
    </>
  )
}

export default GroupDeleteItem
